<div class="flex-column gap-8 mx-16 pt-8" [formGroup]="formGroup">
  <mat-form-field subscriptSizing="dynamic">
    <mat-label>Name</mat-label>
    <input matInput
           autocomplete="off"
           formControlName="name"
           required
           cdkFocusInitial>
    @if (formGroup.controls.name.hasError('required')) {
      <mat-error>
        Name is required.
      </mat-error>
    }
  </mat-form-field>

  <mat-form-field subscriptSizing="dynamic">
    <mat-select formControlName="source" #sourceSelect>
      <mat-option [value]="MapLayerSource.TileUrl">Tile URL</mat-option>
      <mat-option [value]="MapLayerSource.MapLibreConfig">MapLibre Configuration</mat-option>
      <mat-option [value]="MapLayerSource.ArcGisExport">ArcGIS Export / Dynamic Map</mat-option>
      @if (formGroup.controls.source.value === MapLayerSource.RouteImport) {
        <mat-option [value]="MapLayerSource.RouteImport">Route Import</mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (formGroup.controls.source.value === MapLayerSource.RouteImport) {
    <div>
      The layer is imported by Route Management.
    </div>
  }

  @if (formGroup.controls.source.value === MapLayerSource.TileUrl) {
    <mat-form-field subscriptSizing="dynamic">
      <input matInput
             autocomplete="off"
             formControlName="url"
      >
      @if (formGroup.controls.name.hasError('required')) {
        <mat-error>
          URL is required.
        </mat-error>
      }
      <mat-hint>Source URL containing raster tiles, see <a href="https://maplibre.org/maplibre-gl-js/docs/API/classes/RasterTileSource/" target="new">documentation</a> for details</mat-hint>
    </mat-form-field>
  }

  @if (formGroup.controls.source.value === MapLayerSource.ArcGisExport) {
    <div class="flex-row pt-8">
      <mat-form-field class="w-100">
        <mat-label>Base URL (up to MapServer)</mat-label>
        <input matInput
               autocomplete="off"
               formControlName="arcGisBaseUrl"
               placeholder="https://example.com/rest/services/Folder/ServiceName/MapServer"
               cdkFocusInitial>
        <mat-hint>
          Enter the URL ending with /MapServer or /FeatureServer
        </mat-hint>
      </mat-form-field>

      <button
        mat-button
        (click)="fetchLayers()"
        [disabled]="!formGroup.controls.arcGisBaseUrl.value.trim() || isLoading"
        style="min-width: 180px"
      >
        {{ isLoading ? 'Loading...' : 'Fetch Available Layers' }}
      </button>
    </div>


    @if (fetchError) {
      <div class="error-message">
        {{ fetchError }}
      </div>
    }

    @if (!!urlError) {
      <div class="error-message">
        {{ urlError }}
      </div>
    }

    @if (serviceLayers.length > 0) {
      <div class="layers-section">
        <h4>Available Layers</h4>
        @if (serviceInfo) {
          <div class="service-info">
            <strong>Service:</strong> {{ serviceInfo }}
          </div>
        }

        <div class="layers-list" formGroupName="arcGisServiceLayers">
          @for (layer of serviceLayers; track $index) {
            <div class="layer-item">
              <mat-checkbox [formControlName]="layer.id.toString()" (change)="updateSelectedLayers()">
                <span class="layer-id">{{ layer.id }}</span>
                <span class="layer-name">{{ layer.name }}</span>
              </mat-checkbox>
            </div>
          }
        </div>

        <div class="flex-row mt-10">
          <button matButton (click)="setAll(true)">Select All</button>
          <button matButton (click)="setAll(false)">Select None</button>
          <button matButton (click)="selectDefault()">Default Visibility</button>
        </div>

        @if (selectedLayerIds.length > 0) {
          <div class="selected-info">
            Selected layers: {{ selectedLayerIds.join(', ') }}<br />
          </div>
        }
      </div>
    }

    <div class="flex-row">
      <mat-form-field class="w-100">
        <mat-label>Format</mat-label>
        <mat-select
          formControlName="arcGisFormat"
        >
          <mat-option [value]="'png32'">PNG32</mat-option>
          <mat-option [value]="'png24'">PNG24</mat-option>
          <mat-option [value]="'png8'">PNG8</mat-option>
          <mat-option [value]="'jpg'">JPEG</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field class="w-100">
        <mat-label>DPI</mat-label>
        <input matInput
               type="number"
               autocomplete="off"
               formControlName="arcGisDpi"
               min="72"
               max="300">
      </mat-form-field>
    </div>
  }

  @if (formGroup.controls.source.value === MapLayerSource.TileUrl || formGroup.controls.source.value === MapLayerSource.ArcGisExport) {
    <mat-checkbox formControlName="useAsBaseMap">
      Promote to BaseMap
    </mat-checkbox>
  }

  @if (formGroup.controls.source.value === MapLayerSource.TileUrl || formGroup.controls.source.value === MapLayerSource.ArcGisExport) {
    <div class="w-100">

      <mat-checkbox formControlName="useCredentials">
        Use credentials for the server
      </mat-checkbox>

      @if (formGroup.controls.useCredentials.value) {
        <div class="flex-row gap-8 align-items-center w-100">
          <mat-form-field class="w-100" subscriptSizing="dynamic">
            <mat-label>Username</mat-label>
            <input matInput
                   formControlName="username"
                   autocomplete="new-username"/>
          </mat-form-field>
          <mat-form-field class="w-100" subscriptSizing="dynamic">
            <mat-label>Password</mat-label>
            <input matInput
                   formControlName="password"
                   autocomplete="new-password"
                   type="password"/>
          </mat-form-field>

          @if (verifyingCredentials) {
            <mat-spinner diameter="40" mode="indeterminate"></mat-spinner>
          } @else {
            <button mat-icon-button
                    [matTooltip]="'Test connection'"
                    (click)="testCredentials()"
                    class="">
              <mat-icon>refresh</mat-icon>
            </button>
          }
        </div>
      }
    </div>

    <div class="flex-row gap-16 align-items-center">
      <span>Opacity</span>

      <mat-slider min="0.0"
                  max="1.0"
                  step="0.01"
                  class="flex-grow-1">
        <input matSliderThumb
               formControlName="opacity"
        >
      </mat-slider>

      <strong>
        {{ ((formGroup.controls.opacity.value * 100) | number:'1.0-2') + '%' }}
      </strong>
    </div>
  }

  @if (formGroup.controls.source.value === MapLayerSource.MapLibreConfig) {
    <mat-form-field class="json" subscriptSizing="dynamic">
      <mat-label>JSON configuration</mat-label>
      <textarea matInput
                autocomplete="off"
                formControlName="configuration"
                cdkTextareaAutosize
                cdkAutosizeMaxRows="12"
                cdkAutosizeMinRows="5"
                required
      >
      </textarea>
      @if (formGroup.controls.configuration.hasError('required')) {
        <mat-error>
          JSON Configuration is required.
        </mat-error>
      }
    </mat-form-field>
  }
</div>
